import React, { useState } from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { healthCover, lifeCover, short } from '../../utils/money';

// "How much cover?" checks. Rules of thumb only; the page says so under the result.
export function HealthCoverTool() {
  const { lang, t } = useLang();
  const [fam, setFam] = useState(4);
  const [tier, setTier] = useState(1);
  const lakh = healthCover(fam, tier);
  return (
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div>
        <p className="kicker text-brand">{t('toolKick')}</p><h2 className="h2">{t('toolTitle')}</h2>
        <div className="mt-8"><div className="text-sm font-semibold mb-2">{t('tMembers')}</div>
          <div className="inline-flex items-center gap-4 bg-white rounded-2xl p-2 shadow-sm">
            <button type="button" aria-label="−" onClick={() => setFam((f) => Math.max(1, f - 1))} className="w-11 h-11 rounded-xl bg-slate-100 text-xl font-bold">−</button>
            <span className="text-2xl font-extrabold w-8 text-center" aria-live="polite">{fam}</span>
            <button type="button" aria-label="+" onClick={() => setFam((f) => Math.min(8, f + 1))} className="w-11 h-11 rounded-xl bg-slate-100 text-xl font-bold">+</button>
          </div></div>
        <div className="mt-6"><div className="text-sm font-semibold mb-2">{t('tCity')}</div>
          <div className="inline-flex flex-wrap bg-emerald-100/60 rounded-xl p-1 text-sm font-semibold text-emerald-900">
            {[1, 2, 3].map((c) => (
              <button key={c} type="button" aria-pressed={tier === c} onClick={() => setTier(c)} className={`px-3 py-2 rounded-lg transition ${tier === c ? 'bg-white shadow text-emerald-800' : ''}`}>{t(`city${c}`)}</button>
            ))}
          </div></div>
      </div>
      <div className="bg-white rounded-3xl shadow-xl p-8 text-center">
        <div className="text-sm text-slate-500">{t('sugg')}</div>
        <div key={`${fam}-${tier}`} className="bump mt-2 text-5xl font-extrabold text-emerald-600">₹{lakh}{lang === 'bn' ? ' লাখ' : ' L'}</div>
        <div className="mt-6 flex justify-center flex-wrap gap-1.5" aria-hidden="true">{Array.from({ length: fam }, (_, i) => <span key={i} className="text-3xl">{i < 2 ? '🧑' : '🧒'}</span>)}</div>
        <p className="mt-6 text-xs text-slate-400">{t('suggNote')}</p>
      </div>
    </div>
  );
}

export function LifeCoverTool() {
  const { lang, t } = useLang();
  const [age, setAge] = useState(32);
  const [inc, setInc] = useState(40000);
  const [deps, setDeps] = useState(2);
  const need = lifeCover({ age, monthlyIncome: inc, dependants: deps });
  return (
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div>
        <p className="kicker text-brand">{t('toolKick')}</p><h2 className="h2">{t('lToolTitle')}</h2>
        <label className="block mt-8"><div className="flex justify-between text-sm font-semibold mb-2"><span>{t('fAge')}</span><span>{age} {t('yrs')}</span></div>
          <input type="range" min="21" max="60" value={age} onChange={(e) => setAge(+e.target.value)} className="w-full accent-brand" /></label>
        <label className="block mt-5"><div className="flex justify-between text-sm font-semibold mb-2"><span>{t('fIncome')}</span><span>₹{inc.toLocaleString('en-IN')}</span></div>
          <input type="range" min="10000" max="300000" step="5000" value={inc} onChange={(e) => setInc(+e.target.value)} className="w-full accent-brand" /></label>
        <div className="mt-5"><div className="text-sm font-semibold mb-2">{t('lDeps')}</div>
          <div className="flex gap-2">{[0, 1, 2, 3, 4].map((n) => (
            <button key={n} type="button" aria-pressed={deps === n} onClick={() => setDeps(n)} className={`w-12 h-11 rounded-xl font-bold border ${deps === n ? 'bg-ink text-white border-ink' : 'bg-white border-slate-200'}`}>{n === 4 ? '4+' : n}</button>
          ))}</div></div>
      </div>
      <div className="bg-white rounded-3xl shadow-xl p-8 text-center">
        <div className="text-6xl" aria-hidden="true">🛡️</div>
        <div className="mt-3 text-sm text-slate-500">{t('lSugg')}</div>
        <div key={need} className="bump mt-1 text-5xl font-extrabold text-brand">{short(need, lang)}</div>
        <p className="mt-6 text-xs text-slate-400">{t('suggNote')}</p>
      </div>
    </div>
  );
}
